// src/App.js - 修正导入
import React, { Suspense, useEffect, useState } from 'react';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './App.css';
import '@/assets/css/animate.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fontsource/poppins';
import '@fontsource-variable/tilt-warp';
import route from './route';
import NewNav from '@/components/NewNav';
import BottomPage from '@/components/BottomNew';
// 从global文件导入getters
import { getCurrentLanguage } from "@/store/data/global";
import '@fontsource/bowlby-one';


// 自定义Hook：监听窗口大小变化并设置CSS变量
const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setSize({ width, height });
      
      // 设置CSS变量
      document.documentElement.style.setProperty('--vw', `${width / 100}px`);
      document.documentElement.style.setProperty('--vh', `${height / 100}px`);
      document.documentElement.style.setProperty('--window-width', `${width}px`);
      document.documentElement.style.setProperty('--window-height', `${height}px`);
      
      // 根据窗口宽度动态设置根字体大小
      const baseSize = 14;
      let fontSize = baseSize;
      
      if (width >= 1920) {
        fontSize = baseSize + 4;
      } else if (width >= 1200) {
        fontSize = baseSize + 2;
      } else if (width < 768) {
        fontSize = baseSize - 1;
      }
      
      document.documentElement.style.setProperty('--root-font-size', `${fontSize}px`);

      document.documentElement.classList.toggle('is-mobile', width <= 768);
      document.documentElement.classList.toggle('is-tablet', width > 768 && width <= 1024);
    };
    
    // 添加事件监听
    window.addEventListener('resize', handleResize);
    handleResize(); // 初始化
    
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return size;
};

const RouteRenderer = () => {
  const location = useLocation();
  const routes = useRoutes(route);
  // 使用getters获取当前语言
  const currentLanguage = useSelector(getCurrentLanguage);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname, currentLanguage]);

  return routes;
};

const AppContent = () => {
  useWindowSize();

  return (
    <>
      <NewNav />
      <div className='app_warp' style={{ minHeight: "calc(100vh - 125px)" }}>
        <Suspense>
          <RouteRenderer />
        </Suspense>
      </div>
      <BottomPage key="global-footer" />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;